import React from "react";
import PropTypes from "prop-types";
import { Input, Modal } from "antd";
import { Map } from "immutable";
import _noop from "lodash/noop";

class ObjectText extends React.Component {
    state = {
        modalVisible: false
    };
    formRef = React.createRef();
    inputRef = React.createRef();
    toggle = () => {
        this.setState({
            modalVisible: !this.state.modalVisible
        });
    };

    onFocus = e => {
        this.inputRef.current.blur();
        if (this.props.inputForm) {
            this.setState(
                {
                    modalVisible: true
                },
                () => {
                    this.props.onFocus(e);
                }
            );
        }
        this.props.onFocus(e);
    };
    submitForm = () => {
        this.formRef.current.validateFields((err, values) => {
            if (!err) {
                this.setState(
                    {
                        modalVisible: false
                    },
                    () => this.props.onChange(values)
                );
            }
        });
    };

    render() {
        /* eslint-disable no-unused-vars */
        const {
            getValueFromObject,
            value,
            inputForm: FormComponent,
            size,
            onChange,
            ...restProps
        } = this.props;
        /* eslint-enable no-unused-vars */
        if (FormComponent) {
            return (
                <React.Fragment>
                    <Modal
                        visible={this.state.modalVisible}
                        onOk={this.submitForm}
                        onCancel={this.toggle}
                        destroyOnClose={true}
                        closable={true}
                        title={restProps.label || restProps.placeholder}>
                        <FormComponent
                            values={new Map(value)}
                            ref={this.formRef}
                            {...this.props.inputformprops}
                        />
                    </Modal>
                    <Input
                        type="text"
                        {...restProps}
                        ref={this.inputRef}
                        onClick={this.onFocus}
                        onFocus={this.onFocus}
                        value={getValueFromObject(value)}
                        size={size}
                    />
                </React.Fragment>
            );
        }
        return (
            <Input
                type="text"
                {...restProps}
                value={getValueFromObject(value)}
            />
        );
    }
}

ObjectText.defaultProps = {
    onChange: _noop,
    onFocus: _noop,
    size:"default"
};

ObjectText.propTypes = {
    value: PropTypes.object,
    addOnBefore: PropTypes.object,
    addOnAfter: PropTypes.object,
    placeholder: PropTypes.string,
    prefix: PropTypes.object,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    getValueFromObject: PropTypes.func,
    inputForm: PropTypes.func,
    inputformprops: PropTypes.object,
    size: PropTypes.string
};

export default ObjectText;
